<template>
  <div style="background-color: #f5f5f5;min-height: 100vh;padding: 13px 0 100px 0">
    <div v-if="orderList.length === 0" class="noOrder">暂无订单</div>
    <div v-else>
      <div v-for="item in orderList" :key="item.orderId" class="orderItem" @click="toOrder(item)">

        <div class="flex-item border_btm">
          <div>
            <span class="ziti">自提</span>
            <span class="shopName">{{item.shopName}}</span>
          </div>
          <p class="orderRight" v-if="item.isRefund === 1">已退单</p>
          <p class="orderRight" v-if="item.cancelType">已取消</p>
          <p class="orderRight" v-if="item.isRefund === 0 && item.orderStatus === 70">已完成</p>
          <p class="orderRight" v-if="item.isRefund === 0 && item.orderStatus === 10">待支付</p>
          <div class="orderRight" v-if="item.isRefund !== 1 && !item.cancelType && item.orderStatus !== 70 && item.orderStatus !== 10">
            <img src="../assets/coffee_bean.png">
            取餐码：<span style="color: #e60012;font-size: 13px">{{item.takeNo}}</span></div>

        </div>

        <div class="flex-item border_btm" style="padding: 13px 0;">
          <div class="flex-item">
            <img :src="item.orderDetailList[0].productLogo" class="productImg" />
            <div>
              <p style="font-weight: 500;font-size: 16px">{{item.orderDetailList[0].productName}}</p>
              <div style="display: flex">
                <p style="color: #777;font-size: 11px;" v-for="(att,index) in item.orderDetailList[0].attrs">
                  <span>{{att.attributeName}}</span>
                  <span v-if="index !== item.orderDetailList[0].attrs.length-1">/</span>
                </p>
              </div>
            </div>
          </div>
          <p style="font-size: 13px;color: #777;">x {{item.orderDetailList[0].productAmount}}</p>
        </div>

        <div class="flex-item" style="padding-top: 13px;">
          <p style="color: #aaa;font-size: 12px">{{item.orderTime}}</p>
          <p style="font-size: 12px">共计1件商品合计：<span style="font-size: 17px;font-weight: 700">¥ {{item.price /100}}</span></p>
        </div>

      </div >
    </div>
  </div>
</template>
<script>
import {queryOrderList} from "@/api/mxbc";

export default{
  data(){
    return{
      orderList:[]
    }
  },
  mounted() {
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
    this.getOrderList();
  },
  methods: {
    getOrderList(){
      queryOrderList({cardID: localStorage.getItem('cardID')}).then(res => {
        if (res.code !== 0) return
        // res.data.forEach(item => {
        //   let txt = ''
        //   item.orderDetailList[0].attrs.forEach(attr => {
        //     txt = txt + attr.attributeName+'/'
        //   })
        //   item.productAttr = txt
        // })
        this.orderList = res.data

        //console.log(res, '订单查询返回')
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    toOrder(item){
      //console.log(item.orderId)
      localStorage.setItem('orderID', item.orderId);
      this.$router.push({name:'order', params:{orderId: item.orderId}})
    }
  }
}

</script>

<style scoped lang="less">
.noOrder{
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.orderItem{
  -webkit-box-flex: 1;
  background: #fff;
  border-radius: 5px;
  -webkit-flex: 1;
  flex: 1;
  margin: 0 14px 13px;
  padding: 13px;
}
.flex-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ziti{
  background: rgba(230,0,18,.08);
  border-radius: 3px;
  color: #ff5254;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 15px;
  margin-right: 8px;
  padding: 2px 4px;
}
.shopName{
  font-size: 13px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orderRight{
  color: #999;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  font-size: 13px;
  display: flex;
  align-items: center;
  img{
    width: 26px;
    height: 26px;
  }
}
.productImg{
  border-radius: 4px;
  height: 82px;
  margin-right: 8px;
  width: 82px;
}

.border_btm{
  border-bottom: 1px solid #F7F8F9;
  padding-bottom: 13px;
}
</style>